import {
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeRadiusVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Box } from "@caspeco/casper-ui-library.components.box";
import { Flex } from "@caspeco/casper-ui-library.components.flex";
import { Skeleton } from "@caspeco/casper-ui-library.components.skeleton";

interface IStepperSkeleton {
    progressbarProgress?: string;
    hasBackButton?: boolean;
}

/**
 * Skeleton loader for the Stepper component
 * Mimics the layout and appearance of the stepper while content is loading
 */
const StepperSkeleton = ({
    progressbarProgress = "40%",
    hasBackButton = false,
}: IStepperSkeleton) => {
    const progressbarHeight = "0.25rem";

    return (
        <Flex flexDirection="column" pb={ThemeSpaceVariable.Large}>
            <Flex
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <Box
                    flex={1}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    gap={ThemeSpaceVariable.XSmall}
                    fontSize={ThemeFontSizeVariable.Medium}
                >
                    <Flex w="full" textAlign="center" align="center">
                        {hasBackButton ? (
                            <Flex flex={1} align="center">
                                <Skeleton height="24px" width="24px" borderRadius="full" />
                            </Flex>
                        ) : (
                            <Flex flex={1} justifyContent="flex-start" />
                        )}

                        {/* Title and subtitle area */}
                        <Flex direction="column" align="center" flex={3}>
                            {/* Summary text line */}
                            <Flex
                                justify="center"
                                direction="row"
                                gap={ThemeSpaceVariable.XSmall}
                                flexWrap="wrap"
                                align="center"
                            >
                                <Skeleton height="16px" width="120px" />
                            </Flex>

                            {/* Step title */}
                            <Skeleton height="20px" width="160px" mt={ThemeSpaceVariable.Small} />
                        </Flex>

                        {/* Right spacer */}
                        <Flex flex="1" />
                    </Flex>
                </Box>
            </Flex>

            {/* Progress bar */}
            <Box
                position="relative"
                width="full"
                height={progressbarHeight}
                mt={ThemeSpaceVariable.Small}
                bg={ThemeColorVariable.BackgroundDisabled}
                borderRadius={ThemeRadiusVariable.XSmall}
                overflow="hidden"
            >
                {/* Animated progress indicator */}
                <Skeleton
                    height="full"
                    width={progressbarProgress}
                    startColor={ThemeColorVariable.Primary}
                    speed={1}
                    borderRadius={0}
                />
            </Box>
        </Flex>
    );
};

export default StepperSkeleton;
